module.exports = __webpack_public_path__ + "img/bg_general-group-seating.e2963b38.jpg";